import { render, staticRenderFns } from "./ListaPreview.vue?vue&type=template&id=b48bb680"
import script from "./ListaPreview.vue?vue&type=script&lang=js"
export * from "./ListaPreview.vue?vue&type=script&lang=js"
import style0 from "./ListaPreview.vue?vue&type=style&index=0&id=b48bb680&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports